import React, { useState } from 'react'
import FacilityActivation from './facilityActivation'
import Register from './register'

export default function RegisterPage({flag}:any) {
  const [state,setState]=useState(false);
  const handelDisplayFacility = (flag:any)=>{
    setState(false)
  }
  return (
    <div >
      <Register handelDisplayFacility={handelDisplayFacility}/>
      <br/>
      <br/>
      {/* <FacilityActivation state={state}/> */}
    </div>
  )
}
